import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const superAdminRolesRoutes = [
  {
    path: 'role-management',
    component: () => import('./SuperAdminRolesEditView.vue'),
    meta: {
      permissionAction: PermissionActions.SuperAdminLimitedRolesView,
    },
  },
  {
    path: 'role-management/:roleId',
    component: () => import('./SuperAdminRolesEditAPI.vue'),
    meta: {
      permissionAction: PermissionActions.SuperAdminLimitedRolesEndpointsView,
    },
  },
]
